<template lang="pug">
.shipment-comments
  v-container
    v-row(justify-center, style="overflow: hidden")
      v-col
        h2.primary--text {{$tc('Comment._name', 2)}}
  g-comments-timeline(v-model="comment", v-bind="{ comments, loading }", @post="postComment")
</template>

<script>
import axios from 'axios';

export default {
  props: {
    shipmentId: null,
    shipmentBusinessScopeId: null,
  },
  data: () => ({
    loading: false,
    comment: null,
    comments: []
  }),
  methods: {
    async load () {
      this.comments = (await axios.get(`comment?load[]=User`, { params: { withoutGlobalBusinessScope: true, where: [`x => x.shipmentId == ${this.shipmentId}`] }})).data.data;
    },
    async postComment() {
      try {
        this.loading = true;
        const c = { shipmentId: this.shipmentId, commentText: this.comment, businessScopeId: this.shipmentBusinessScopeId };
        await axios.post(`Comment`, c);

        this.comment = null;
        this.comments = (await axios.get(`comment?load[]=User`, { params: { withoutGlobalBusinessScope: true, where: [`x => x.shipmentId == ${this.shipmentId}`] }})).data.data;
      } catch(e) {
        console.log('ERROR POST ', this.$cleanString(e));
      } finally {
        this.loading = false;
      }
    },
  },
  async created() {
    await this.load();
  },
}
</script>
